import(/* webpackMode: "eager", webpackExports: ["ArticleLinksClient"] */ "/vercel/path0/apps/web/src/app/(cms)/blog/[article-slug]/components/article-links/article-links-client.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.1.4_@babel+core@7.26.0_@opentelemetry+api@1.9.0_@playwright+test@1.45.0_babel-p_cc7e0a5edfaec6ce3ea112e130fd2444/node_modules/next/dist/client/legacy/image.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/dist/components/link.js");
